const country = import.meta.env.VITE_APP_COUNTRY_CODE?.toLowerCase();

export function mask_CPF_CNPJ(type) {
  if (type === "cpf") {
    if (country === "ar") return "##.###.###"; // DNI
    return "###.###.###-##"; // CPF
  }

  // CNPJ (BR) ou CUIT (AR)
  if (type === "cnpj") {
    if (country === "ar") return "##-########-#"; // CUIT
    return "XX.XXX.XXX/XXXX-##"; // CNPJ
  }

  return "";
}

export function placeholder_CPF_CNPJ(type) {
  if (type === "cpf") {
    if (country === "ar") return "xx.xxx.xxx"; // DNI
    return "xxx.xxx.xxx-xx"; // CPF
  }

  if (type === "cnpj") {
    if (country === "ar") return "xx-xxxxxxxx-x"; // CUIT
    return "xx.xxx.xxx/xxxx-xx"; // CNPJ
  }

  return "";
}
